import React from 'react'
import { Controller } from 'react-hook-form'
import { FormFeedback, Input, Label } from 'reactstrap'
import InputPasswordToggle from '@components/input-password-toggle'
import { defaultPasswordRules } from './options'


const InputPassword = ({
  label,
  control,
  errors,
  options,
  passwordRules = defaultPasswordRules
}) => {
  return (
    <React.Fragment>
      <Label className="form-label" for={options.id}>
        { label }
      </Label>
      <Controller
        id={options.id}
        name={options.name}
        rules={{ validate: { passwordRules } }}
        control={control}
        render={({ field }) => (
          <InputPasswordToggle
            className="input-group-merge"
            placeholder=""
            invalid={errors[options.name] && true}
            {...field}
            autoComplete="off"
          />
        )}
      />
      {errors[options.name] && (
        <FormFeedback>{errors[options.name]?.message}</FormFeedback>
      )}
    </React.Fragment>
  )
}

export default InputPassword
